import { SAVE_THOUSANDS_REGIONS } from 'luxPlus/constants/benefits'

/**
 * @param regionCode - current region code
 * @returns save amount copy - depending on if the region has a high denomination currency such as ZAR, THB, etc.
 */
function getRegionSaveAmountCopy(regionCode: string) {
  const isSaveThousandsRegion = SAVE_THOUSANDS_REGIONS.includes(regionCode)
  return isSaveThousandsRegion ? 'thousands' : 'hundreds'
}

export default getRegionSaveAmountCopy
